import React, { useState } from "react";
import { useSelector } from "react-redux";

const usePropertyWisePerformanceData = (data, comparisonData) => {
  const hotels = useSelector((state) => state.auth.hotels);
  const [period, setPeriod] = useState("Today");
  const [metric, setMetric] = useState("Revenue");

  const handlePeriodChange = (val) => {
    setPeriod(val);
  };
  const handleMetricChange = (val) => {
    setMetric(val);
  };

  let getChartData = (data) => {
    let formattedData = [];
    switch (period.toLowerCase()) {
      case "today":
        formattedData = data?.hotelWiseMetricsBreakdown?.td || [];
        break;
      case "mtd":
        formattedData = data?.hotelWiseMetricsBreakdown?.mtd || [];
        break;
      case "ytd":
        formattedData = data?.hotelWiseMetricsBreakdown?.ytd || [];
        break;
      default:
        formattedData = [];
        break;
    }
    formattedData.forEach((data) => {
      let hotelData = hotels.find((hotel) => hotel.hotelId === data.hotelId);
      data.hotelName = hotelData.hotelName;
    });

    return formattedData;
  };

  const dataKeyMapper = (metric) => {
    let dataKey = "";
    switch (metric.toLowerCase()) {
      case "revenue":
        dataKey = "revenue";
        break;
      case "occupancy":
        dataKey = "occupancy";
        break;
      case "adr":
        dataKey = "adr";
        break;
      case "revpar":
        dataKey = "revPar";
        break;
      default:
        dataKey = "revenue";
        break;
    }
    return dataKey;
  };

  const chartData = getChartData(data);
  const comparisonChartData = getChartData(comparisonData);
  const mergedChartData = chartData.map((curr) => {
    const match = comparisonChartData.find(
      (comp) => comp.hotelId === curr.hotelId
    );

    // Create prefixed comparison keys
    const prefixedComparisonData = match
      ? Object.fromEntries(
          Object.entries(match).map(([key, value]) => [`ly_${key}`, value])
        )
      : {};

    return {
      ...curr,
      ...prefixedComparisonData,
    };
  });
  console.log("mergedChartData", mergedChartData);
  return {
    chartData,
    comparisonChartData,
    mergedChartData,
    handleMetricChange,
    handlePeriodChange,
    period,
    metric,
    dataKey: dataKeyMapper(metric),
  };
};

export default usePropertyWisePerformanceData;
